module.exports = __webpack_public_path__ + "media/logos/logo-a17973e5.png";